import { Component, OnInit, ViewEncapsulation, input, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ErrorMessageService } from '@app/shared/services/material-error-message.service';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
    selector: 'material-form-check-box',
    templateUrl: './form-check-box.component.html',
    styleUrls: ['./form-check-box.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [MatCheckboxModule, ReactiveFormsModule]
})
export class FormCheckBoxComponent implements OnInit {
  private errorMessageService = inject(ErrorMessageService);

  readonly control = input<FormControl>(undefined);
  readonly title = input<string>(undefined);

  ngOnInit() {
  }

  getError() {
    return this.errorMessageService.getErrorMessageUsingFormControl(this.control());
  }
}
